<section *transloco="let t; read: 'dashboard-options-component.dashboard-option-history'">
  <div class="section-title">
    <h3>{{ t('history') }}</h3>
    <p>
      {{ t('history-details') }}
    </p>
  </div>

  <div class="section-field section-field--full-width">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
      <ng-container matColumnDef="revision">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('revision') }}
        </th>

        <td mat-cell *matCellDef="let element; index as i">
          @if (i) {
            <span>
              {{ t('revision-other', { revision: element.revision }) }}
            </span>
          } @else {
            {{ t('revision-current', { revision: element.revision }) }}
            @if (element.isRestored) {
              {{ t('revision-current-restored') }}
            }
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('timestamp') }}
        </th>

        <td mat-cell *matCellDef="let element">
          {{ element.timestamp | lexDate: 'long' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>{{ t('user') }}</th>

        <td mat-cell *matCellDef="let element">
          <span [class.ellipsis-loader]="!usersById.has(element.user)">
            {{ usersById.get(element.user) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>

        <td mat-cell *matCellDef="let element; index as i" (click)="$event.stopPropagation()">
          @if (i) {
            @if (!dashboard.locked) {
              <div
                [matMenuTriggerFor]="menuTrigger"
                [matMenuTriggerData]="{ $implicit: element.revision }"
              >
                <ng-container *ngTemplateOutlet="kabobIconTemplate"></ng-container>
              </div>
            } @else {
              <ng-container
                *ngTemplateOutlet="kabobIconTemplate; context: { $implicit: true }"
              ></ng-container>
            }

            <ng-template #kabobIconTemplate let-isDisabled>
              <xi-icon-button
                color="CX"
                buttonSize="small"
                icon="kabob"
                [disabled]="isDisabled"
              ></xi-icon-button>
            </ng-template>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length">
          <div class="xi-loader-container__center">
            <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <mat-menu #menuTrigger class="menu-with-xi-icons">
    <ng-template matMenuContent let-revision>
      <button
        mat-menu-item
        [disabled]="isImpactMenuItemDisabled"
        (click)="onRestoreRevision(revision)"
      >
        <xi-icon icon="reply" color="orca"></xi-icon>
        <div>
          {{ t('restore') }}
        </div>
      </button>
    </ng-template>
  </mat-menu>
</section>
